(function () {
  let ckPrevHtmlOverflow = null;
  let ckPrevBodyOverflow = null;

  function ckLockScroll() {
    try {
      if (ckPrevHtmlOverflow === null) ckPrevHtmlOverflow = document.documentElement.style.overflow;
      if (ckPrevBodyOverflow === null) ckPrevBodyOverflow = document.body.style.overflow;
      document.documentElement.style.setProperty('overflow', 'hidden', 'important');
      document.body.style.setProperty('overflow', 'hidden', 'important');
      document.documentElement.classList.add('ck-scrolling-disabled');
      document.body.classList.add('ck-scrolling-disabled');
    } catch (e) {
    }
  }

  function ckUnlockScroll() {
    try {
      document.documentElement.classList.remove('ck-scrolling-disabled');
      document.body.classList.remove('ck-scrolling-disabled');
      document.documentElement.style.overflow = ckPrevHtmlOverflow ?? '';
      document.body.style.overflow = ckPrevBodyOverflow ?? '';
      ckPrevHtmlOverflow = null;
      ckPrevBodyOverflow = null;
    } catch (e) {
    }
  }

  function ckEnsureOverlay() {
    let overlay = document.getElementById('gdpr-blocking-page-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'gdpr-blocking-page-overlay';
      document.body.appendChild(overlay);
    }

    overlay.style.setProperty('position', 'fixed', 'important');
    overlay.style.setProperty('top', '0', 'important');
    overlay.style.setProperty('right', '0', 'important');
    overlay.style.setProperty('bottom', '0', 'important');
    overlay.style.setProperty('left', '0', 'important');
    overlay.style.setProperty('background-color', '#000', 'important');
    overlay.style.setProperty('opacity', '.75', 'important');
    overlay.style.setProperty('z-index', '2147483646', 'important');
    overlay.style.setProperty('display', 'block', 'important');
    overlay.style.setProperty('pointer-events', 'auto', 'important');

    overlay.addEventListener(
      'click',
      function () {
        const banner = document.getElementById('pandectes-banner');
        if (banner) banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      { passive: true }
    );

    return overlay;
  }

  function ckRemoveOverlay() {
    const overlay = document.getElementById('gdpr-blocking-page-overlay');
    if (!overlay) return;
    try {
      overlay.parentNode && overlay.parentNode.removeChild(overlay);
    } catch (e) {
    }
  }

  function ckBannerIsVisible() {
    const banner = document.getElementById('pandectes-banner');
    if (!banner) return false;
    return !!(banner.offsetWidth || banner.offsetHeight || banner.getClientRects().length);
  }

  function ckOpenCookieSettings() {
    try {
      if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
        window.Cookiebot.renew();
        return true;
      }
      if (window.UC_UI && typeof window.UC_UI.showSecondLayer === 'function') {
        window.UC_UI.showSecondLayer();
        return true;
      }
      if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
        window.OneTrust.ToggleInfoDisplay();
        return true;
      }

      const cc = window.cookieconsent;
      const ccInstance =
        (cc && cc.instance) || (cc && Array.isArray(cc.instances) && cc.instances[0]) || null;
      if (ccInstance && typeof ccInstance.open === 'function') {
        ccInstance.open();
        return true;
      }
      if (cc && typeof cc.open === 'function') {
        cc.open();
        return true;
      }

      const reopenSelectors = [
        '.cc-revoke',
        '#pandectes-reopen',
        '.pd-reopen',
        '.pd-reopen-button',
        '.pd-cookie-preferences-button',
        '[data-pandectes-reopen]'
      ];

      for (const selector of reopenSelectors) {
        const el = document.querySelector(selector);
        if (!el) continue;
        el.click();
        return true;
      }

      const banner = document.getElementById('pandectes-banner');
      if (banner) {
        banner.style.display = '';
        banner.classList.remove('cc-invisible');
        const windowEl = banner.querySelector('.cc-window, .pd-cookie-banner-window');
        if (windowEl) {
          windowEl.style.display = '';
          windowEl.classList.remove('cc-invisible');
        }

        const buttons = banner.querySelectorAll('button, [role="button"]');
        for (const btn of buttons) {
          const text = (btn.textContent || '').trim().toLowerCase();
          if (!text) continue;
          if (
            text.includes('einstellungen') ||
            text.includes('settings') ||
            text.includes('preferences') ||
            text.includes('präferenzen') ||
            text.includes('customize') ||
            text.includes('anpassen')
          ) {
            btn.click();
            return true;
          }
        }

        banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    } catch (e) {
    }
    return false;
  }

  function ckMaybeCloseOnClick(target) {
    if (!target) return false;
    if (target.closest('.cc-btn.cc-btn-decision')) return true;
    if (target.closest('.cc-btn.cc-btn-accept-all')) return true;
    if (target.closest('.cc-btn.cc-allow')) return true;
    if (target.closest('.cc-btn.cc-dismiss')) return true;
    if (target.closest('.cc-btn.cc-btn-accept-selected')) return true;
    return false;
  }

  document.addEventListener('click', function (e) {
    const target = e.target && e.target.closest ? e.target.closest('.ck-js-open-cookie-settings') : null;
    if (!target) return;
    e.preventDefault();

    const opened = ckOpenCookieSettings();
    if (opened) {
      ckEnsureOverlay();
      ckLockScroll();

      setTimeout(function () {
        if (!ckBannerIsVisible()) {
          ckRemoveOverlay();
          ckUnlockScroll();
        }
      }, 2000);
    }
  });

  document.addEventListener('click', function (e) {
    if (!ckMaybeCloseOnClick(e.target)) return;
    setTimeout(function () {
      ckRemoveOverlay();
      ckUnlockScroll();
    }, 50);
  });
})();